import { withStyles, Checkbox as CheckboxMui, FormControlLabel, FormControlLabelProps } from '@material-ui/core';

import { ReactComponent as CheckboxCheckedIcon } from './icons/CheckboxCheckedIcon.svg';
import { ReactComponent as CheckboxCheckedDisabledIcon } from './icons/CheckboxCheckedDisabledIcon.svg';
import { ReactComponent as CheckboxIcon } from './icons/CheckboxIcon.svg';
import { ReactComponent as CheckboxIndeterminateIcon } from './icons/CheckboxIndeterminateIcon.svg';

const CheckboxBase = withStyles(() => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}))(CheckboxMui);

const FormControlLabelBase = withStyles((theme) => ({
  label: {
    '&$disabled': {
      color: theme.palette.darkGrey[15],
    },
  },

  disabled: {
    color: theme.palette.darkGrey[15],
  },
}))(FormControlLabel);

interface Props extends FormControlLabelProps {
  isCheckedDisabled?: boolean;
  indeterminate?: boolean;
  defaultChecked?: boolean;
}

function Checkbox(props: Omit<Props, 'control'>) {
  const { defaultChecked, indeterminate, isCheckedDisabled } = props;
  return (
    <FormControlLabelBase
      control={
        <CheckboxBase
          checkedIcon={isCheckedDisabled ? <CheckboxCheckedDisabledIcon /> : <CheckboxCheckedIcon />}
          defaultChecked={defaultChecked}
          disableRipple
          icon={<CheckboxIcon />}
          indeterminate={indeterminate}
          indeterminateIcon={<CheckboxIndeterminateIcon />}
        />
      }
      {...props}
    />
  );
}

export default Checkbox;
